"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8969],{

/***/ 1946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Banner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sticky top-0 z-50 flex h-10 items-center bg-[#173d2f] px-6 font-haboro-soft text-[16px] text-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: "font-normal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-semibold",
                    children: "Free delivery over $79 in Victoria"
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "hidden sm:inline-block",
                    children: "(National delivery coming soon)"
                })
            ]
        })
    });
};


/***/ }),

/***/ 4972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ BookIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);



var BookIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        className: "".concat(className),
        width: "50px",
        height: "50px",
        viewBox: "0 0 50 50",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "History@2x"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Our-Story",
                    transform: "translate(-180.000000, -1084.000000)",
                    stroke: "#86CB92",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "History",
                        transform: "translate(180.000000, 1084.000000)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M37.5,8.63333333 C40.7604463,8.10934378 44.0561263,7.83493594 47.3583333,7.81230199 C47.6420974,7.80814037 47.9161154,7.91595073 48.1208333,8.1125 C48.3216867,8.30717782 48.435805,8.57445491 48.4375,8.85416667 L48.4375,41.7041667 C48.4318548,42.2771087 47.9687754,42.7401882 47.3958333,42.7458333 C30.11875,42.9604167 25,48.4375 25,48.4375 L25,13.5041667 C25,13.5041667 19.8854167,8.03333333 2.64166667,7.81230199 C2.35646802,7.80703404 2.08074768,7.91492461 1.875,8.1125 C1.67567853,8.30787286 1.56309871,8.57506231 1.5625,8.85416667 L1.5625,41.7041667 C1.56814516,42.2771087 2.03122464,42.7401882 2.60416667,42.7458333 C19.88125,42.9604167 25,48.4375 25,48.4375",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M25,47.4104167 C25.3291627,44.7103256 26.5250963,42.1898004 28.4083333,40.2270833 C30.8316611,37.6129781 34.0096446,35.8193546 37.5,35.0958333 L37.5,2.58958333 C37.4935295,2.24914543 37.3146301,1.93528695 37.025,1.75625 C36.7181069,1.56336597 36.3425986,1.51319685 35.9958333,1.61875 C33.0725556,2.45874921 30.4437064,4.10232132 28.4083333,6.3625 C26.5259047,8.32411157 25.3300307,10.843049 25,13.5416667",
                                id: "Shape"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 6179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DogIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);



var DogIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        className: "".concat(className),
        width: "62px",
        height: "53px",
        viewBox: "0 0 62 53",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "Mission@2x"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Our-Story",
                    transform: "translate(-765.000000, -1083.000000)",
                    stroke: "#86CB92",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Mission",
                        transform: "translate(766.567080, 1084.262401)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M16.2912317,50 L8.59630222,50 C6.83192003,42.3976606 5.54733403,34.6918959 4.75014515,26.9283205 C4.74806151,24.3762106 5.76024115,21.927876 7.56387222,20.1222781 C9.36750329,18.3166801 11.8147333,17.3018326 14.3668439,17.3011379 L31.6706035,17.3011379 C33.5348634,17.4540604 35.3213383,16.5230949 36.2639652,14.9074511",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M43.2195522,8.64663625 C43.2195522,12.3643228 44.1817461,15.3793718 39.3707766,15.3793718 C34.559807,15.3793718 33.6002349,13.4602276 35.5193791,7.69230769 C36.6913156,4.17912013 37.8003293,0 45.1360746,0 C48.6389022,0.169047167 51.6861196,2.45316244 52.8310041,5.76791988 L58.598924,7.68968591 C58.598924,7.68968591 60.761894,18.3891773 50.9039945,17.3063814 C48.9822285,25.0013109 50.9039945,30.7718526 45.1360746,34.6101411 L45.1360746,49.9973782 L48.9848503,49.9973782",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M25.9079272,28.8422212 C25.9079272,28.8422212 25.9079272,36.5371506 16.2912317,36.5371506 L14.0469865,50",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                id: "Shape",
                                points: "45.1413182 50 37.4490105 50 35.5246227 34.6127628 31.6784689 34.6127628"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M6.67977975,21.1499135 C6.67977975,21.1499135 -2.9447811,19.2281474 0.91185987,7.69230769",
                                id: "Shape"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ TeamIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);



var TeamIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        className: "".concat(className),
        width: "58px",
        height: "51px",
        viewBox: "0 0 58 51",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "Team@2x"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Our-Story",
                    transform: "translate(-178.000000, -1477.000000)",
                    stroke: "#86CB92",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Team",
                        transform: "translate(179.785000, 1478.785714)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M40.4761905,47.6190476 L40.4761905,44.047619 C40.4761905,34.6357143 33.5738095,33.1166667 27.0619048,30.7142857 C24.897619,29.9119048 25.2547619,24.2619048 26.2142857,23.2071429 C28.4595238,20.7333333 30.3690476,17.8333333 30.3690476,10.8261905 C30.3690476,3.75714286 25.7571429,0 20.2380952,0 C14.7214286,0 10.1071429,3.75714286 10.1071429,10.8214286 C10.1071429,17.8261905 12.0119048,20.7261905 14.2642857,23.202381 C15.2190476,24.2547619 15.5785714,29.9071429 13.4166667,30.7095238 C7.02142857,33.0738095 0,34.5642857 0,44.047619 L0,47.6190476 L40.4761905,47.6190476 Z",
                                id: "Stroke-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M48.5769048,47.6214286 L54.762619,47.6214286 L54.762619,45.5904762 C54.762619,38.3928571 49.4840476,37.2309524 44.5054762,35.3880952 C42.8388095,34.7761905 43.1221429,30.4547619 43.8554762,29.65 C46.215,27.0928571 47.3721429,23.65 47.0340476,20.1857143 C47.2388095,18.0238095 46.5054762,15.8833333 45.0245238,14.302381 C43.5411905,12.7190476 41.4530952,11.847619 39.2864286,11.9071429 C38.7054762,11.902381 38.1269048,11.9571429 37.562619,12.0738095",
                                id: "Stroke-3"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 1602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SearchIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);



var SearchIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        className: "".concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "none",
            stroke: "#014032",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2.5",
            d: "M8.86125909,17.7225182 C13.7551973,17.7225182 17.7225182,13.7551973 17.7225182,8.86125909 C17.7225182,3.96732083 13.7551973,0 8.86125909,0 C3.96732083,0 0,3.96732083 0,8.86125909 C0,13.7551973 3.96732083,17.7225182 8.86125909,17.7225182 Z M15.1265841,15.1264867 L21.9991197,22",
            transform: "translate(2 2)"
        })
    }));
};


/***/ }),

/***/ 9257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fr": function() { return /* reexport */ AccountIcon; },
  "ol": function() { return /* reexport */ ArrowRight; },
  "yf": function() { return /* reexport */ AustraliaMapIcon; },
  "HQ": function() { return /* reexport */ CheckoutChevronIcon; },
  "LQ": function() { return /* reexport */ EmailIcon; },
  "TK": function() { return /* reexport */ LoadingSpinner; },
  "b_": function() { return /* reexport */ PawIcon; },
  "T0": function() { return /* reexport */ RedHeartIcon; },
  "W1": function() { return /* reexport */ SearchIcon/* SearchIcon */.W; },
  "Iq": function() { return /* reexport */ ShoppingBagIcon; }
});

// UNUSED EXPORTS: BookIcon, DogIcon, TeamIcon

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/common/icons/LoadingSpinner.tsx



var LoadingSpinner = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "text-component-primary-1 h-6 w-6 animate-spin ".concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/common/icons/SearchIcon.tsx
var SearchIcon = __webpack_require__(1602);
;// CONCATENATED MODULE: ./src/components/common/icons/AccountIcon.tsx



var AccountIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "My Account"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Nutrition",
                    transform: "translate(-1338.000000, -76.000000)",
                    stroke: "#014032",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Nav-Bar",
                        transform: "translate(0.000000, 44.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "Account",
                            transform: "translate(1340.000000, 34.000000)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M0,22 C0.0184437912,20.429059 0.345475429,18.8770602 0.9625,17.43225 C1.63625,16.083375 4.453625,15.148375 7.990125,13.839375 C8.952625,13.484625 8.789,10.987625 8.3655,10.5215 C6.99890058,9.04473446 6.32844881,7.05439333 6.523,5.05175 C6.40047662,3.77749848 6.8131099,2.50965077 7.66215572,1.55160582 C8.51120155,0.593560875 9.7202598,0.0315269177 11,0 C12.2797402,0.0315269177 13.4887985,0.593560875 14.3378443,1.55160582 C15.1868901,2.50965077 15.5995234,3.77749848 15.477,5.05175 C15.6722157,7.05265494 15.0038582,9.04171898 13.64,10.51875 C13.2165,10.984875 13.05975,13.481875 14.015375,13.836625 C17.551875,15.145625 20.36925,16.080625 21.043,17.4295 C21.6584891,18.875547 21.9836562,20.4285002 22,22 L0,22 Z"
                            })
                        })
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/EmailIcon.tsx



var EmailIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "#014032",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M1.07948508,9.39103701 C0.453794265,9.21452784 0.0162253495,8.65079711 0.000440610327,8.00087763 C-0.0153441289,7.35095815 0.394342109,6.76664994 1.01072643,6.55997422 L21.0115224,0.0368707097 C21.278652,-0.0502094683 21.5720497,0.0196696714 21.7712464,0.217815754 C21.9704431,0.415961836 22.0418728,0.708985914 21.9562065,0.976572299 L15.4380855,20.9873333 C15.2323147,21.6048382 14.6474442,22.0155793 13.9967546,21.9995468 C13.346065,21.9835143 12.7821327,21.5444677 12.6070227,20.9175781 L10.3688787,11.619216 L1.07948508,9.39103701 Z M21.7718536,0.216241109 L10.3688787,11.619216"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/ShoppingBagIcon.tsx



var ShoppingBagIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Shopping Bag"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Cart-Drawer",
                    transform: "translate(-1341.000000, -76.000000)",
                    stroke: "#014032",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Bag",
                        transform: "translate(1342.951393, 77.750000)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8.04160711,22.5000001 L1.49960711,22.5000001 C1.06803338,22.5000001 0.657419772,22.3138873 0.372711738,21.9895461 C0.0880037035,21.6652048 -0.0432097729,21.2339491 0.0126071138,20.8060001 L1.87060711,6.55600006 C1.96808058,5.80866865 2.6049459,5.24969949 3.35860711,5.24999994 L4.47460711,5.24999994 C5.2278877,5.25020183 5.86418285,5.80904612 5.96160711,6.55600006 L8.04160711,22.5000001 Z",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M13.2916071,5.25000006 L18.7246071,5.25000006 C19.4778877,5.25020183 20.1141828,5.80904612 20.2116071,6.55600006 L22.0706071,20.8060001 C22.1264466,21.2341221 21.9951039,21.6655444 21.7101726,21.9899218 C21.4252414,22.3142992 21.0143553,22.5000002 20.5826071,22.5000002 L8.04160711,22.5000002",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                x1: "4.47460711",
                                y1: "5.25000006",
                                x2: "11.0416071",
                                y2: "5.25000006",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M17.0416071,9.75000006 L17.0416071,3 C17.0416071,1.92820328 16.4698104,0.937822198 15.5416071,0.401923799 C14.6134039,-0.1339746 13.4698103,-0.1339746 12.5416071,0.401923799 C11.6134039,0.937822198 11.0416071,1.92820328 11.0416071,3 L11.0416071,9.75000006",
                                id: "Shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8.62660711,0.503000063 C7.79121776,1.06035965 7.29011856,1.99874768 7.29160381,3.00300006 L7.29160381,5.25000006",
                                id: "Shape"
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/common/icons/GreenBook.tsx
var GreenBook = __webpack_require__(4972);
// EXTERNAL MODULE: ./src/components/common/icons/GreenDog.tsx
var GreenDog = __webpack_require__(6179);
// EXTERNAL MODULE: ./src/components/common/icons/GreenTeam.tsx
var GreenTeam = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/components/common/icons/PawIcon.tsx



var PawIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "57px",
        height: "54px",
        viewBox: "0 0 57 54",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Unique@2x"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Our-Difference",
                    transform: "translate(-176.000000, -1880.000000)",
                    stroke: "#993955",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M210.225598,1905.81818 C211.677922,1906.80139 212.778946,1908.10448 213.547592,1909.68104 C214.579713,1911.79741 216.053457,1913.51749 217.982035,1914.88378 C220.3708,1916.57565 222.134081,1918.75164 222.857744,1921.657 C222.928789,1921.94297 222.986268,1922.23465 223.019113,1922.52704 C223.058384,1922.87548 223.064097,1923.2275 223.092658,1923.72017 C222.947711,1927.11964 221.09839,1929.49055 217.957401,1930.89218 C214.661826,1932.36236 211.261289,1932.27524 207.895382,1931.17886 C205.605866,1930.43342 203.399177,1930.43699 201.115373,1931.18422 C197.822654,1932.26204 194.509228,1932.3163 191.253638,1930.97751 C189.218671,1930.14067 187.613903,1928.78974 186.671749,1926.77476 C185.61321,1924.50988 185.753872,1922.22287 186.746008,1919.96691 C187.519652,1918.2072 188.699219,1916.75202 190.184031,1915.54782 C191.434643,1914.53355 192.605284,1913.43324 193.639547,1912.20619 C194.470314,1911.22048 195.180053,1910.1373 195.843024,1909.02557 C198.884049,1903.92494 205.311332,1902.49118 210.225598,1905.81818 Z M228.332947,1898.42857 C229.875595,1900.09189 230.529997,1902.14935 230.904503,1904.32497 C231.020888,1905.00044 231.053734,1905.68305 231.059089,1906.37387 C231.035526,1910.09857 229.481454,1913.00429 226.302621,1914.95964 C224.614313,1915.99819 222.776417,1916.27451 220.908174,1915.39055 C219.401228,1914.67796 218.511198,1913.44484 218.022091,1911.86649 C217.263442,1909.41989 217.632949,1907.09146 218.66864,1904.82015 C219.576164,1902.83017 220.642201,1900.93658 222.118801,1899.30146 C222.653248,1898.70918 223.240532,1898.17866 223.936348,1897.77738 C225.547185,1896.84808 227.068055,1897.06443 228.332947,1898.42857 Z M184.801508,1897.61301 C185.699035,1898.05071 186.417343,1898.71546 187.050325,1899.46233 C188.873583,1901.61333 190.250935,1904.02744 191.057067,1906.73145 C191.637211,1908.67645 191.557598,1910.64073 190.779312,1912.53003 C189.621523,1915.34079 186.702238,1916.73206 183.692629,1915.42076 C180.273528,1913.9313 178.460979,1911.17446 178.021855,1907.49795 C177.976158,1907.11559 178.015786,1906.72324 178.015786,1906.33552 C178.005076,1904.08206 178.484899,1901.94178 179.578426,1899.95858 C179.954003,1899.27776 180.416333,1898.65441 180.997548,1898.13246 C182.086791,1897.15425 183.484491,1896.9711 184.801508,1897.61301 Z M212.606366,1882.28696 C214.301101,1882.90067 215.648106,1884.01454 216.844096,1885.31549 C218.801591,1887.44578 220.354592,1889.84062 220.740165,1892.75669 C221.16358,1895.96051 220.386009,1898.91443 218.132551,1901.31533 C215.371779,1904.25675 211.311128,1904.04219 208.766705,1900.90405 C207.437194,1899.26501 206.756729,1897.37285 206.514675,1895.29183 C206.439203,1894.64582 206.430031,1894.00155 206.429239,1893.48358 L206.429261,1893.07343 C206.429157,1893.01119 206.428885,1892.95226 206.428278,1892.89699 C206.530027,1890.20048 206.677116,1887.87991 207.380429,1885.63609 C207.563219,1885.05273 207.793848,1884.49008 208.094095,1883.95778 C209.101582,1882.17058 210.67529,1881.58793 212.606366,1882.28696 Z M197.949857,1882.01481 C199.092651,1882.03302 199.990536,1882.5564 200.638869,1883.50355 C201.548892,1884.83306 201.916971,1886.3525 202.185087,1887.90515 C202.446777,1889.41924 202.536387,1890.94939 202.586368,1892.48668 C202.72596,1895.03396 202.42607,1897.49555 201.083706,1899.74009 C200.420021,1900.85039 199.580686,1901.7929 198.471094,1902.47872 C196.409351,1903.75254 193.981315,1903.69899 192.013109,1902.28273 C189.847476,1900.72437 188.810357,1898.50126 188.348741,1895.94148 C187.671846,1892.18858 189.155944,1889.11578 191.360134,1886.27004 C192.431527,1884.88661 193.701417,1883.70669 195.23157,1882.84415 C196.067691,1882.3729 196.967361,1881.99946 197.949857,1882.01481 Z",
                        id: "Unique"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/RedHeartIcon.tsx



var RedHeartIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "61px",
        height: "54px",
        viewBox: "0 0 61 54",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Care@2x"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Our-Difference",
                    transform: "translate(-764.000000, -1486.000000)",
                    stroke: "#993955",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M794.324543,1538.15756 L769.972758,1512.75937 C765.583422,1508.37348 764.495645,1501.66979 767.27293,1496.12101 L767.27293,1496.12101 C769.344479,1491.97911 773.280642,1489.08538 777.851924,1488.34371 C782.423207,1487.60204 787.072362,1489.10284 790.347186,1492.37732 L794.324543,1496.35214 L798.301899,1492.37732 C801.576724,1489.10284 806.225878,1487.60204 810.797161,1488.34371 C815.368444,1489.08538 819.304607,1491.97911 821.376156,1496.12101 L821.376156,1496.12101 C824.149553,1501.66743 823.063099,1508.36621 818.678868,1512.75175 L794.324543,1538.15756 Z",
                        id: "Care"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/ArrowRight.tsx



var ArrowRight = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, fill = props.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "36px",
        height: "36px",
        viewBox: "0 0 36 36",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                fillOpacity: "0.3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Home",
                    transform: "translate(-534.000000, -1591.000000)",
                    fill: fill !== null && fill !== void 0 ? fill : "#D0FFCE",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Bold",
                        transform: "translate(534.000000, 1591.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18,0 C8.0588745,0 0,8.0588745 0,18 C0,27.9411255 8.0588745,36 18,36 C27.9411255,36 36,27.9411255 36,18 C35.9892527,8.06332957 27.9366704,0.0107472714 18,0 Z M27.468,19.083 L19.2,27.816 C18.9290667,28.1050306 18.5521841,28.2713682 18.1560596,28.2768786 C17.759935,28.2821201 17.3786772,28.1260716 17.1,27.8445 L16.6575,27.3945 C16.0728548,26.7955417 16.0454538,25.848251 16.5945,25.2165 L20.0445,21.357 C20.5935,20.742 20.3685,20.238 19.5435,20.238 L9.7935,20.238 C8.96507288,20.238 8.2935,19.5664271 8.2935,18.738 L8.2935,17.238 C8.2935,16.4095729 8.96507288,15.738 9.7935,15.738 L19.521,15.738 C20.346,15.738 20.571,15.24 20.007,14.6325 L16.4505,10.7655 C15.893646,10.1438303 15.9153091,9.19656369 16.5,8.601 L16.95,8.151 C17.2297022,7.87231438 17.6095789,7.71758819 18.0043996,7.72146265 C18.3992203,7.7254846 18.7759269,7.88777663 19.05,8.172 L27.465,16.9095 C28.0383308,17.5201176 28.039643,18.4708021 27.468,19.083 Z",
                            id: "Shape"
                        })
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/AustraliaMapIcon.tsx



var AustraliaMapIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        width: "57px",
        height: "54px",
        viewBox: "0 0 57 54",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Australia@2x"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Tucker-Tub---UI",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Our-Difference",
                    transform: "translate(-176.000000, -1486.000000)",
                    stroke: "#993955",
                    strokeWidth: "2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M231.017392,1507.90589 C228.880502,1509.62106 225.513735,1499.92734 222.338433,1499.62663 C221.398382,1499.05462 219.75692,1489.42622 218.861168,1494.33021 C218.371871,1495.11784 218.394897,1488.57752 216.508536,1488 C214.255641,1490.06906 215.520556,1495.95002 213.425087,1497.3626 C205.176609,1492.46199 208.182972,1495.63592 208.67665,1490.14027 C207.455158,1490.34412 203.423022,1488.33412 203.471952,1489.37742 C203.967507,1491.1927 200.109315,1488.71029 199.182028,1493.79023 C198.523792,1493.51092 197.743794,1494.75681 197.53944,1493.65858 C194.631437,1489.3365 191.921531,1497.18377 191.469775,1496.76243 C189.616827,1493.72065 190.309102,1499.17963 188.726581,1499.47671 C185.798556,1501.2308 182.065755,1501.18538 179.566584,1503.70006 C179.043749,1504.1781 179.311674,1502.96424 178.854663,1503.04533 C177.066913,1506.438 180.49262,1511.52181 178.059523,1508.81316 C177.398283,1510.40582 182.506498,1517.72801 180.534667,1522.02081 C188.630349,1527.10575 200.529911,1510.11036 207.112275,1522.31501 C207.814435,1524.37382 209.392075,1521.29325 210.014521,1520.5359 C210.475162,1520.03972 210.296587,1522.97976 209.707303,1523.14719 C209.002639,1523.29799 209.379811,1523.83822 209.95508,1523.58356 C210.770242,1522.38196 211.893248,1521.50761 211.191213,1523.80756 C212.736817,1525.05908 213.788994,1528.19597 216.000092,1529.52007 C218.028612,1531.56261 220.644288,1526.42574 219.89933,1529.21298 C220.835502,1528.76573 221.407642,1529.95056 222.057619,1530.34112 C221.479848,1527.97973 227.027554,1528.10236 226.887773,1527.24816 C228.567777,1516.57322 232.507685,1521.21403 231.017392,1507.90589 Z M220.494208,1533.11422 C217.688444,1531.60478 221.9402,1543.63274 224.501816,1534.61678 C224.907395,1531.81727 221.834207,1534.37175 220.494208,1533.11422 Z",
                        id: "Australia"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/CheckoutChevronIcon.tsx



var CheckoutChevronIcon = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "".concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "26",
        viewBox: "0 0 15 26",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "#014032",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "3",
            d: "M16.3483243,16.3483243 L5.86654655,5.86654655 C5.72897759,5.72917338 5.65167567,5.54273783 5.65167567,5.34832433 C5.65167567,5.15391083 5.72897759,4.96747528 5.86654655,4.83010211 L16.3483243,-5.65167567",
            transform: "matrix(1 0 0 -1 -3.652 18.78)"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/common/icons/index.ts















/***/ }),

/***/ 8969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(9855);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3342);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/index.tsx + 12 modules
var constants = __webpack_require__(7522);
;// CONCATENATED MODULE: ./src/components/common/layout/footer/customer-service-map.tsx



var CustomerServiceMap = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "grid text-base leading-8",
                children: constants/* CustomerServiceLinks.map */.ku.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link.path,
                        children: link.text
                    }, link.id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/accordion-customer.tsx




var CustomerServiceAccordion = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto w-full rounded-2xl px-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                className: "flex w-full items-center justify-between text-left text-sm font-medium text-colorFifteen",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "p-4 text-md font-bold",
                                        children: "Customer Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                        className: "".concat(open ? "rotate-180" : "", " h-5 w-5 ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                className: "pb-6 text-sm text-colorFifteen",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerServiceMap, {})
                            })
                        ]
                    });
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/nav-links-map.tsx



// TODO: this is essentially the same component as customer-service-map, fix
var NavLinksMap = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "grid text-base leading-8",
                children: constants/* FooterLinks.map */.qo.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link.path,
                        children: link.text
                    }, link.id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/accordion-navlinks.tsx




var NavLinksAccordion = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto w-full px-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                className: "flex w-full items-center justify-between text-left text-sm font-medium text-colorFifteen",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "p-4 text-md font-bold",
                                        children: "Tucker Tub"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                        className: "".concat(open ? "rotate-180" : "", " h-5 w-5")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                className: "pb-6 text-sm text-colorFifteen",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinksMap, {})
                            })
                        ]
                    });
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/components/common/layout/footer/copyright.tsx



var CopyRightFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 pt-8 text-[15px] md:grid-cols-[3fr_1fr]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Copyright \xa9 2022 Tucker Tub Pet Food."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "block sm:hidden"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-block space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "All rights reserved."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/terms-and-conditions",
                                    className: "underline decoration-0 underline-offset-2",
                                    children: "Terms of Service"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/privacy-policy",
                                    className: "underline decoration-0 underline-offset-2",
                                    children: "Privacy"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/policies/cookie-policy",
                                    className: "underline decoration-0 underline-offset-2",
                                    children: "Cookies"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center pt-2 sm:justify-end sm:self-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pr-2",
                        children: "Created by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.tigerheart.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/icons/logo-tigerheart.svg",
                            alt: "Tigerheart",
                            width: 87,
                            height: 16
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/logo-footer.tsx


var LogoFooter = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " grid grid-cols-[3fr_10fr] gap-6 lg:grid-cols-1"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/icons/TT-logo.svg",
                    alt: "Tucker Tub",
                    width: 72,
                    height: 70
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "py-0 pr-6 text-base",
                    children: "Tucker Tub is all natural dog food, made farm fresh in Australia using locally sourced ingredients. Our nutrient-rich recipes are vet and pet nutritionist approved. We deliver straight to your door in Victoria, Australia, making it easy for your dog to eat and live healthy."
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/payments-footer.tsx


var PaymentsFooter = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "py-4 text-base",
                children: "Online Payment Accepted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/visa.svg",
                        alt: "Visa",
                        height: 24,
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/mastercard.svg",
                        alt: "Mastercard",
                        height: 24,
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/amex.svg",
                        alt: "Amex",
                        height: 24,
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/applepay.svg",
                        alt: "Apple Pay",
                        height: 24,
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/googlepay.svg",
                        alt: "Google Pay",
                        height: 24,
                        width: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/payments-logo/paypal.svg",
                        alt: "Paypal",
                        height: 24,
                        width: 32
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/social.tsx


var SocialFooter = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "py-4 text-base",
                children: "Follow Tucker Tub"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.facebook.com/tuckertubpetfood",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/social/facebook.svg",
                            alt: "Facebook",
                            height: 24,
                            width: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.instagram.com/tuckertubpetfood",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/social/instagram.svg",
                            alt: "Instagram",
                            height: 24,
                            width: 24
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/footer/index.tsx









var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "bg-colorFourteen p-8 text-colorFifteen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoFooter, {
                        className: "col-span-2 md:col-span-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-6 hidden border-y-2 py-6 sm:col-span-full sm:flex sm:flex-col sm:justify-center md:col-span-1 md:my-0 lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinksAccordion, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerServiceAccordion, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-start-2 col-end-4 hidden grid-cols-2 gap-20 justify-self-center lg:grid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "py-4 text-md font-bold",
                                        children: "Tucker Tub"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinksMap, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "py-4 text-md font-bold",
                                        children: "Customer Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerServiceMap, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid sm:col-span-2 sm:grid-cols-2 md:grid-cols-2 lg:col-start-4 lg:grid-cols-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsFooter, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-6 block border-y-2 py-4 sm:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinksAccordion, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerServiceAccordion, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialFooter, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyRightFooter, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/context/index.tsx + 7 modules
var context = __webpack_require__(598);
;// CONCATENATED MODULE: ./src/components/common/layout/main/index.tsx




var Main = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, children = props.children;
    var isSearchOpen = (0,context/* useSearch */.Rx)().isSearchOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "min-h-layoutHeight pt-navbarHeight ".concat(className),
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/common/banner/index.tsx
var banner = __webpack_require__(1946);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/common/icons/index.ts + 9 modules
var icons = __webpack_require__(9257);
;// CONCATENATED MODULE: ./src/components/common/icons/MenuHamburger.tsx




var MenuHamburger = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className;
    var toggleNav = (0,context/* useGlobalState */.j1)().toggleNav;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: toggleNav,
        title: "Navigation Menu",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            className: "".concat(className, " h-6 w-6 cursor-pointer"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            strokeWidth: "2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M4 8h16M4 16h16"
            })
        }))
    });
};

// EXTERNAL MODULE: ./src/utilities/index.tsx + 15 modules
var utilities = __webpack_require__(5266);
// EXTERNAL MODULE: ./src/components/common/layout/navbar/helpers/index.ts
var helpers = __webpack_require__(4234);
// EXTERNAL MODULE: ./src/components/common/layout/navbar/helpers/RenderLinks.tsx
var RenderLinks = __webpack_require__(4630);
;// CONCATENATED MODULE: ./src/components/common/layout/navbar/NavMenu.tsx

















var DynamicSearchModal = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(4507), __webpack_require__.e(5675), __webpack_require__.e(2133), __webpack_require__.e(4221), __webpack_require__.e(5812), __webpack_require__.e(2828)]).then(__webpack_require__.bind(__webpack_require__, 2828));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.SearchModal);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2828)
            ];
        }
    },
    ssr: false
});
var DynamicMegaMenuModal = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(4507), __webpack_require__.e(2133), __webpack_require__.e(5812), __webpack_require__.e(2859)]).then(__webpack_require__.bind(__webpack_require__, 2859));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.MegaMenuModal);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2859)
            ];
        }
    },
    ssr: false
});
var DynamicMobileMenu = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(4507), __webpack_require__.e(2133), __webpack_require__.e(5812), __webpack_require__.e(456)]).then(__webpack_require__.bind(__webpack_require__, 456));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.MobileMenu);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(456)
            ];
        }
    },
    ssr: false
});
var DynamicCart = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(4507), __webpack_require__.e(5675), __webpack_require__.e(2133), __webpack_require__.e(5812), __webpack_require__.e(1990), __webpack_require__.e(6378)]).then(__webpack_require__.bind(__webpack_require__, 7850));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.Cart);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7850)
            ];
        }
    },
    ssr: false
});
function MobileNavMenu(props) {
    var ref, ref1;
    // TODO: products and articles are not used
    var products = props.products, articles = props.articles;
    var ref2 = (0,context/* useCart */.jD)(), cart = ref2.cart, openCartModal = ref2.openCartModal;
    var ref3 = (0,context/* useSearch */.Rx)(), isSearchOpen = ref3.isSearchOpen, handleToggleSearch = ref3.handleToggleSearch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid h-navbarHeight w-full grid-cols-2 items-center justify-between px-4 lg:hidden lg:grid-cols-3",
        id: "navbar-mobile-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMobileMenu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-inherit w-full lg:col-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utilities/* ActiveLink */.O$, {
                    href: "/",
                    className: "justify-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "h-full w-full max-w-[190px] object-contain pt-2",
                        id: "logo-desktop-img",
                        src: "/assets/icons/logo_text.svg",
                        alt: "Tucker Tub",
                        height: 190,
                        width: 40
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "m-auto flex w-full items-center justify-end gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            title: "Search",
                            className: "py-2",
                            onClick: handleToggleSearch,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            title: "Cart",
                            className: "cart-button py-2 text-xl uppercase md:inline-block",
                            onClick: openCartModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShoppingBagIcon */.Iq, {}),
                                    ((ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-[-4px] left-4 flex h-4 w-4 items-center justify-center rounded-full bg-colorTen text-colorFifteen",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs",
                                            children: (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length
                                        })
                                    }) : null
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuHamburger, {})
                    })
                ]
            })
        ]
    });
}
function DesktopNavMenu(props) {
    var ref, ref1;
    var products = props.products, articles = props.articles;
    var ref2 = (0,context/* useCart */.jD)(), cart = ref2.cart, openCartModal = ref2.openCartModal;
    var ref3 = (0,context/* useGlobalState */.j1)(), openMegaMenu = ref3.openMegaMenu, isMegaMenuOpen = ref3.isMegaMenuOpen, closeMegaMenu = ref3.closeMegaMenu;
    var ref4 = (0,context/* useSearch */.Rx)(), isSearchOpen = ref4.isSearchOpen, handleActivateSearch = ref4.handleActivateSearch, handleCloseSearch = ref4.handleCloseSearch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "navbar-desktop-container",
                className: "hidden h-navbarHeight items-center px-8 lg:grid lg:grid-cols-[3fr_24fr_1fr] xl:grid-cols-[3fr_20fr_1fr]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utilities/* ActiveLink */.O$, {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "h-full w-full max-w-[190px] object-contain pt-2",
                            id: "logo-desktop-img",
                            src: "/assets/icons/logo_text.svg",
                            alt: "Tucker Tub",
                            height: 190,
                            width: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "desktop-nav-ul",
                        className: "flex h-inherit w-full list-none items-center justify-center space-x-6 text-center text-lg font-bold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "h-inherit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/shop",
                                    className: "h-inherit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "flex h-inherit w-full items-center py-2 text-colorFourteen transition-colors hover:text-colorSixteen",
                                        onMouseEnter: function() {
                                            if (isSearchOpen) {
                                                handleCloseSearch();
                                            }
                                            openMegaMenu();
                                        },
                                        children: [
                                            "Shop",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                className: "h-6 w-6 transition ".concat(isMegaMenuOpen ? "rotate-180" : "")
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers/* RenderLinks */.K, {
                                linkType: RenderLinks/* LinkType.NAV_DESKTOP */.U.NAV_DESKTOP,
                                linkFunction: constants/* DesktopLinks */.R3
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "flex items-center justify-end gap-x-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "py-2",
                                    title: "Search",
                                    onMouseEnter: function() {
                                        if (isMegaMenuOpen) {
                                            closeMegaMenu();
                                        }
                                        handleActivateSearch();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utilities/* ActiveLink */.O$, {
                                    href: "/account",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AccountIcon */.fr, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "cart-button hidden py-2 text-xl uppercase md:inline-block",
                                        onMouseEnter: openCartModal,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShoppingBagIcon */.Iq, {}),
                                                ((ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute top-[-4px] left-4 flex h-4 w-4 items-center justify-center rounded-full bg-colorTen text-colorFifteen",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-xs",
                                                        children: (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length
                                                    })
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCart, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden lg:block",
                children: [
                    isSearchOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchModal, {
                        products: products,
                        articles: articles
                    }),
                    isMegaMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMegaMenuModal, {})
                ]
            })
        ]
    });
}
var NavMenu = function() {
    var ref = (0,context/* useSearch */.Rx)(), handleSetSearchLoaded = ref.handleSetSearchLoaded, searchLoaded = ref.searchLoaded;
    var ref1 = (0,react.useState)([]), products = ref1[0], setProducts = ref1[1];
    var ref2 = (0,react.useState)([]), articles = ref2[0], setArticles = ref2[1];
    var abortController = (0,context/* useCart */.jD)().abortController;
    (0,react.useEffect)(function() {
        // initial fetch on the client for products for search
        handleSetSearchLoaded(false);
        function fetchProducts() {
            return _fetchProducts.apply(this, arguments);
        }
        function _fetchProducts() {
            _fetchProducts = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetch("".concat("https://preview.tuckertub.com.au", "/api/products"), {
                                method: "POST",
                                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
                            });
                        case 3:
                            response = _ctx.sent;
                            _ctx.next = 6;
                            return response.json();
                        case 6:
                            data = _ctx.sent;
                            setProducts(data);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log("fetchProducts error", _ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _fetchProducts.apply(this, arguments);
        }
        function fetchPosts() {
            return _fetchPosts.apply(this, arguments);
        }
        function _fetchPosts() {
            _fetchPosts = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, featuredMedia, featuredMediaResponse, filtermediaWithImage, combinedData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetch("".concat("https://staging-tuckertub-stagingtut.kinsta.cloud", "/wp-json/wp/v2/posts?categories=").concat("52", "&status=publish"), {
                                method: "GET",
                                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
                            });
                        case 3:
                            response = _ctx.sent;
                            _ctx.next = 6;
                            return response.json();
                        case 6:
                            data = _ctx.sent;
                            featuredMedia = data.map(function(post) {
                                return post.featured_media;
                            });
                            _ctx.next = 10;
                            return Promise.all(featuredMedia.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
                                    var response;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return fetch("".concat("https://staging-tuckertub-stagingtut.kinsta.cloud", "/wp-json/wp/v2/media/").concat(id));
                                            case 2:
                                                response = _ctx.sent;
                                                return _ctx.abrupt("return", response.json());
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(id) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        case 10:
                            featuredMediaResponse = _ctx.sent;
                            filtermediaWithImage = featuredMediaResponse.filter(function(media) {
                                return data.map(function(post) {
                                    return post.featured_media;
                                }).includes(media.id);
                            });
                            combinedData = data.map(function(post) {
                                var ref;
                                var ref1;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, post), {
                                    featuredMedia: (ref1 = (ref = filtermediaWithImage.find(function(media) {
                                        return media.id === post.featured_media;
                                    })) === null || ref === void 0 ? void 0 : ref.source_url) !== null && ref1 !== void 0 ? ref1 : ""
                                });
                            });
                            // console.log('SetArticles', searchLoaded)
                            setArticles(combinedData);
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.name === "AbortError") {
                                console.log("fetchPosts AbortError", _ctx.t0);
                            }
                            console.log("fetchPosts error", _ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }));
            return _fetchPosts.apply(this, arguments);
        }
        Promise.all([
            fetchProducts(),
            fetchPosts()
        ]).then(function() {
            handleSetSearchLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavMenu, {
                products: products,
                articles: articles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopNavMenu, {
                products: products,
                articles: articles
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/navbar/index.tsx



var Navbar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "sticky top-0 z-[100]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* Banner */.j, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "fixed top-[40px] z-[100] min-h-navbarHeight w-full bg-colorFifteen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenu, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/layout/index.tsx







var DynamicNewsletter = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(3760), __webpack_require__.e(6462)]).then(__webpack_require__.bind(__webpack_require__, 6462));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.Newsletter);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6462)
            ];
        }
    },
    ssr: false
});
var DynamicToaster = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var component;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return __webpack_require__.e(/* import() */ 6501).then(__webpack_require__.bind(__webpack_require__, 6501));
            case 2:
                component = _ctx.sent;
                return _ctx.abrupt("return", component.Toaster);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    },
    ssr: false
});
var Layout = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicNewsletter, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToaster, {
                position: "bottom-right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 4630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ RenderLinks; },
/* harmony export */   "U": function() { return /* binding */ LinkType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(598);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5266);



var LinkType;
(function(LinkType) {
    LinkType[LinkType["MENU"] = 0] = "MENU";
    LinkType[LinkType["PROFILE"] = 1] = "PROFILE";
    LinkType[LinkType["NAV_MOBILE"] = 2] = "NAV_MOBILE";
    LinkType[LinkType["NAV_DESKTOP"] = 3] = "NAV_DESKTOP";
})(LinkType || (LinkType = {}));
function RenderLinkType(props) {
    var handleCloseOnEnterDesktopLink = function handleCloseOnEnterDesktopLink(event) {
        var target = event.target;
        if (target.classList.contains("desktop-nav-link") && isMegaMenuOpen) {
            closeMegaMenu();
        }
        if (target.classList.contains("desktop-nav-link") && isSearchOpen) {
            handleCloseSearch();
        }
    };
    var data = props.data, linkType = props.linkType;
    var path = data.path, text = data.text;
    var ref = (0,_context__WEBPACK_IMPORTED_MODULE_1__/* .useGlobalState */ .j1)(), closeMegaMenu = ref.closeMegaMenu, isMegaMenuOpen = ref.isMegaMenuOpen;
    var ref1 = (0,_context__WEBPACK_IMPORTED_MODULE_1__/* .useSearch */ .Rx)(), isSearchOpen = ref1.isSearchOpen, handleCloseSearch = ref1.handleCloseSearch;
    if (linkType === LinkType.MENU) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utilities__WEBPACK_IMPORTED_MODULE_2__/* .MenuLink */ .Uk, {
            href: path,
            children: text
        });
    }
    if (linkType === LinkType.NAV_DESKTOP) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utilities__WEBPACK_IMPORTED_MODULE_2__/* .ActiveLink */ .O$, {
            href: path,
            className: "desktop-nav-link",
            closeMegaMenuIfOpen: handleCloseOnEnterDesktopLink,
            children: text
        });
    }
    if (linkType === LinkType.NAV_MOBILE) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utilities__WEBPACK_IMPORTED_MODULE_2__/* .ActiveLink */ .O$, {
            href: path,
            children: text
        });
    }
    return null;
}
var RenderLinks = function(props) {
    var linkType = props.linkType, linkFunction = props.linkFunction;
    var links = linkFunction().map(function(link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "h-inherit",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderLinkType, {
                data: link,
                linkType: linkType
            })
        }, link.id);
    });
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: links
    });
};


/***/ }),

/***/ 4234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* reexport safe */ _RenderLinks__WEBPACK_IMPORTED_MODULE_0__.K; }
/* harmony export */ });
/* harmony import */ var _RenderLinks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4630);



/***/ })

}]);